import React from 'react'

const HamburgerMenuIcon: React.FC = () => {
  return (
    <svg
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.673828"
        width="26"
        height="2.69388"
        rx="1.34694"
        fill="black"
      />
      <rect y="6.95898" width="26" height="2.69388" rx="1.34694" fill="black" />
      <rect y="13.2451" width="26" height="2.69388" rx="1.34694" fill="black" />
    </svg>
  )
}

export default HamburgerMenuIcon
